import useWidth from './useWidth';

export default function useMobile() {
  const width = useWidth();
  return width === 'sm' || width === 'xs';
}
